import {View} from 'react-native'

import {atoms as a, useTheme} from '#/alf'
import {Text} from '#/components/Typography'
import {TREND_RANK_PILL} from '../data/labels'

/**
 * Green "#N Trend Globally / in {region}" pill shown at the top of every Top
 * trends card. Colours are locked by design (`TREND_RANK_PILL`). The label is
 * built by `useTrendRankLabel` and passed in already localised.
 */
export function TrendRankPill({label}: {label: string}) {
  return (
    <View
      style={[
        a.flex_row,
        a.align_center,
        a.justify_center,
        a.rounded_full,
        {
          height: 24,
          paddingHorizontal: 10,
          backgroundColor: TREND_RANK_PILL.background,
        },
      ]}>
      <Text
        style={[
          a.text_xs,
          a.font_bold,
          a.leading_snug,
          {color: TREND_RANK_PILL.text},
        ]}
        numberOfLines={1}>
        {label}
      </Text>
    </View>
  )
}

/**
 * Top-line of a Top trends card: the green rank pill, a separator dot, then the
 * category label. Replaces the usual "category · activity status" row on the
 * three trend cards when they're rendered inside the ranked block.
 */
export function TrendRankHeader({
  rankLabel,
  categoryLabel,
}: {
  rankLabel: string
  categoryLabel: string
}) {
  const t = useTheme()
  return (
    <View style={[a.flex_row, a.align_center, a.gap_xs]}>
      <TrendRankPill label={rankLabel} />
      <View
        style={[
          a.rounded_full,
          {
            width: 4,
            height: 4,
            backgroundColor: t.atoms.text_contrast_medium.color,
            opacity: 0.97,
          },
        ]}
      />
      <Text style={[a.text_xs, a.font_bold, t.atoms.text_contrast_medium]}>
        {categoryLabel}
      </Text>
    </View>
  )
}
